import {
  DashboardBillingOverviewDocument,
  type DashboardBillingOverviewQuery,
  type DashboardBillingOverviewQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_BILLING_LOADER = async () => {
  const { data } = await client.query<
    DashboardBillingOverviewQuery,
    DashboardBillingOverviewQueryVariables
  >({
    query: DashboardBillingOverviewDocument,
    variables: { period: "mtd" },
  });

  return data;
};
